/// <reference path="../../global/fn.js" />


;(function ($) {

    $.widget("nsp.benefitsCarousel", {
        options: {
        },

        _create: function () {
            this.wrap = this.element;
            
            this._createDotContainer();

            $(document).on("window-resized", ()=> {
                this.iniSlick();
            });

            this.iniSlick();
        },

        iniSlick: function () {
            

            if (api.vars.windW < api.vars.scr.tablet) {               

                if (!this.wrap.hasClass('slick-initialized')) {
                    this.wrap.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        infinite: false,
                        variableWidth: true,
                        appendDots: this.wrap.parent().find('.carousel_dots')
                    });
                }
            } else {
                if (this.wrap.hasClass('slick-initialized')) {
                    this.wrap.slick('unslick');
                }
            }

        },

        _createDotContainer() {
            $('<div class="carousel_dots"></div>').insertBefore(this.wrap);
        },

    });
})(jQuery);